<template>
  <div v-loading="isLoging">
    <el-dialog
      :title=title
      width="40%"
      top="2rem"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      :destroy-on-close="true"
      @close="close()"
    >
      <div style="margin-top: 1rem;margin-right: 100px;">
        <el-form ref="videoFormRef" :rules="rules" :model="form" label-width="140px" >
          <el-form-item label="摄像头名称" prop="name">
            <el-input v-model="form.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="智能盒子对应密钥" prop="cameraIndexCode">
            <el-input v-model="form.cameraIndexCode" clearable></el-input>
          </el-form-item>
          <el-form-item label="所属船舶" prop="shipId">
            <el-select
              v-model="shipId"
              style="width: 100%"
              placeholder="请选择所属船舶"
              @change="changeShip"
            >
              <el-option v-for="ship in shipList" :key="ship.shipId" :label="ship.shipName" :value="ship.shipId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="视频位置" prop="cameraIndex">
            <el-input type="number" min="0" v-model="form.cameraIndex" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <div style="float: right;">
              <el-button type="primary" @click="onSubmit" :loading="dialogLoading" >保存</el-button>
              <el-button @click="close">取消</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "videoEdit",
  props: {},
  computed: {},
  created() {},
  data() {
    var validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入智能盒子对应密钥'));
      } else {
        if (value.replace(/^ +| +$/g,'') === '') {
          callback(new Error('请输入智能盒子对应密钥'));
          this.form.cameraIndexCode = value.replace(/^ +| +$/g,'')
        } else {
          callback();
        }
      }
    };
    return {
      title: '编辑摄像头',
      listChangeCallback: null,
      showDialog: false,
      isLoging: false,
      dialogLoading: false,
      form: {
        id: '',
        shipId: '',
        name: '',
        cameraIndexCode: '',
        cameraIndex: ''
      },
      shipId: '',
      shipList:{},
      rules: {
        name: [{ required: true, message: "请输入摄像头名称", trigger: "blur" }],
        cameraIndexCode: [{ validator: validateCode, trigger: "blur" }],
        shipId: [{ required: true, message: "请选择所属船舶", trigger: "blur" }]
      },
    };
  },
  methods: {
    openDialog: function (data, callback) {
      this.getShipList()
      this.showDialog = true;
      this.listChangeCallback = callback;
      this.form.id = data.id;
      this.form.cameraIndex = data.cameraIndex;
      this.form.name = data.name;
      this.form.cameraIndexCode = data.cameraIndexCode;
      this.form.shipId = this.shipId = parseInt(data.shipId);
    },
    getShipList(){
      let that = this;
      this.$axios({ method: 'get', url:`/api/ship/DropDownList` }).then( res => {
        that.shipList = res.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    changeShip(val) {
      this.form.shipId = val
    },
    onSubmit: function () {
      this.dialogLoading = true;
      var that = this;
      this.$refs.videoFormRef.validate(flag => {
        //表单验证通过
        if (flag) {
          this.$axios({ method: 'post', url:`/api/video/update`, params: {...this.form} }).then( res => {
            if (res.data.code == 200) {
              that.$message.success('修改成功')
              that.showDialog = false;
              if (that.listChangeCallback != null) {
                that.listChangeCallback();
                that.dialogLoading = false;
              }
            } else {
              that.$message.error(res.data.msg)
              this.dialogLoading = false;
            }
          }).catch(error => {
            this.dialogLoading = false;
          });
        } else {
          that.dialogLoading = false;
          return this.$message.error('请按照格式要求输入数据')
        }
      })
    },
    close() {
      this.form = {
        id: '',
        shipId: '',
        name: '',
        cameraIndexCode: '',
        cameraIndex: '',
      }
      this.shipId = ''
      // this.$refs.videoFormRef.resetFields()
      this.showDialog = false;
      this.dialogLoading = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dialog/videoEdit.vue